import client from './client';

export interface TimesheetLine {
  id: number;
  timesheet_id: number;
  work_date: string;
  hours: number;
  activity_type: string;
  activity_label: string;
  description?: string | null;
}

export interface Timesheet {
  id: number;
  company_id: number;
  user_id: number;
  employee_id?: number | null;
  week_start: string;
  week_end: string;
  week_label: string;
  total_hours: number;
  status: 'pending' | 'approved' | 'rejected' | 'cancelled';
  status_label: string;
  comment?: string | null;
  rh_comment?: string | null;
  reviewed_by?: number | null;
  reviewed_at?: string | null;
  created_at: string;
  user_name?: string | null;
  user_email?: string | null;
  employee_name?: string | null;
  lines?: TimesheetLine[];
}

export interface TimesheetLineInput {
  work_date: string;
  hours: number;
  activity_type: string;
  description?: string;
}

export const timesheetsApi = {
  listMine: () =>
    client.get<{ success: boolean; data: { timesheets: Timesheet[] } }>('/timesheets/me'),

  create: (data: { week_start: string; comment?: string; lines: TimesheetLineInput[] }) =>
    client.post<{ success: boolean; data: Timesheet; message?: string }>('/timesheets', data),

  cancel: (id: number) =>
    client.post<{ success: boolean; data: Timesheet; message?: string }>(`/timesheets/${id}/cancel`),

  list: (params?: { status?: string; page?: number; per_page?: number }) =>
    client.get<{
      success: boolean;
      data: { timesheets: Timesheet[]; pending_count?: number };
    }>('/timesheets', { params }),

  review: (id: number, data: { action: 'approve' | 'reject'; rh_comment?: string }) =>
    client.post<{ success: boolean; data: Timesheet; message?: string }>(
      `/timesheets/${id}/review`,
      data,
    ),

  meta: () =>
    client.get<{
      success: boolean;
      data: { activity_types: { value: string; label: string }[] };
    }>('/timesheets/meta'),
};
